import { BlockType } from './block.types'

export const initialState: Readonly<BlockType> = Object.freeze({
  chainId: '',
  blockNumber: 0,
})
